<template>
  <div class="task-card" v-if="eventoActualStore">
    <!-- Encabezado: Título y submenú de opciones -->
    <div class="task-header">
      <h5 class="task-title">{{ tarea.nombre_tarea.nombre }}</h5>
      <div class="options-menu" v-if="!soloLectura">
        <button class="btn-options" @click="toggleMenu">
          <font-awesome-icon icon="fas fa-ellipsis-v" />
        </button>
        <div v-if="mostrarMenu" class="menu-dropdown">
          <button class="btn-delete" @click.stop="emitirEliminacion"
            :disabled="eventoActualStore.evento_finalizado">
            <font-awesome-icon icon="fas fa-trash" /> Eliminar
          </button>
        </div>
      </div>
    </div>

    <!-- Información Compacta reorganizada -->
    <div class="info-compact">
      <!-- Izquierda: Objetivo y Fecha -->
      <div class="info-left">
        <div class="info-item objective">
          <font-awesome-icon icon="fas fa-info-circle" class="icon-info" />
          <span>{{ tarea.objeto.nombre }}</span>
        </div>
        <div class="info-item date">
          <font-awesome-icon icon="fas fa-calendar" class="icon-info" />
          <span>{{ tareaFechaLegible }}</span>
        </div>
      </div>
      <!-- Derecha: Badges para Costo y Duración con estilo minimalista -->
      <div class="info-right">
        <span class="badge badge-cost">
          <font-awesome-icon icon="fas fa-dollar-sign" class="icon-badge" /> {{ tarea.costo_final_usd }} $
        </span>
        <span class="badge badge-duration">
          <font-awesome-icon icon="fas fa-clock" class="icon-badge" /> {{ tarea.duracion_horas }} h
        </span>
      </div>
    </div>

    <!-- Cumplimiento (si existe) -->
    <div v-if="tarea.cumpli_etiqueta" class="compliance-summary">
      <div class="compliance-indicator" :style="{ backgroundColor: tarea.cumpli_grupo.color || 'var(--app-primary)' }">
      </div>
      <a href="#" @click.prevent="abrirCumplimientoModal" class="compliance-link">
        {{ tarea.cumpli_etiqueta.nombre }}
      </a>
    </div>
    <p> {{ tarea.tipo_planificacion_tarea }}</p>


    <!-- Botón para expandir/ocultar detalles -->
    <button class="btn-toggle-details" @click="toggleDetalles">
      <font-awesome-icon :icon="mostrarDetalles ? 'fas fa-angle-up' : 'fas fa-angle-down'" />
      <span>{{ mostrarDetalles ? 'Ocultar Detalles' : 'Ver Detalles' }}</span>
    </button>

    <!-- Detalles Expandidos -->
    <div v-if="mostrarDetalles" class="task-details">
      <p><strong>{{ tarea.objeto.tipo_objeto }}:</strong> {{ tarea.objeto.nombre }}</p>

      <div v-if="tarea.valor_tarea.length" class="task-parameters">
        <h6>Parámetros:</h6>
        <ul>
          <li v-for="valor in tarea.valor_tarea" :key="valor.atributo.id">
            <strong>{{ valor.atributo.nombre }}:</strong> {{ valor.valor }}
          </li>
        </ul>
      </div>

      <div v-if="tarea.tarea_usa_items.length" class="task-items">
        <h6>Items Utilizados:</h6>
        <ul>
          <li v-for="item in tarea.tarea_usa_items" :key="item.id">
            {{ item.inventario_item.nombre }} - {{ item.cantidad }} {{ item.inventario_item.unidad_de_medida }}
          </li>
        </ul>
      </div>
      <div v-if="tarea.personal?.length" class="task-personal">
        <h6>Personal Participante:</h6>
        <ul>
          <li v-for="personal in tarea.personal" :key="personal.personal.id">
            {{ personal.personal.nombre }} {{ personal.personal.apellido }}
          </li>
        </ul>
      </div>
    </div>

    <!-- Modal para Cumplimiento -->
    <div v-if="mostrarModalCumplimiento" class="modal-overlay" @click.self="cerrarCumplimientoModal">
      <div class="modal-content">
        <h4>{{ tarea.cumpli_etiqueta.nombre }}</h4>
        <p><strong>Grupo:</strong> {{ tarea.cumpli_grupo.nombre }}</p>
        <p><strong>Descripción:</strong> {{ tarea.cumpli_etiqueta.descripcion }}</p>
        <p>
          <strong>Obligatoria:</strong>
          <span
            :class="{ 'text-success': tarea.cumpli_etiqueta.es_obligatoria, 'text-danger': !tarea.cumpli_etiqueta.es_obligatoria }">
            {{ tarea.cumpli_etiqueta.es_obligatoria ? 'Sí' : 'No' }}
          </span>
        </p>
        <button class="btn btn-close-modal" @click="cerrarCumplimientoModal">Cerrar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tarea: {
      type: Object,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mostrarDetalles: false,
      mostrarModalCumplimiento: false,
      mostrarMenu: false,
    };
  },
  computed: {
    tareaFechaLegible() {
      return new Date(this.tarea.fecha_creacion).toLocaleString();
    },
    eventoActualStore() {
      return this.$store.state.eventoActual;
    },
  },
  methods: {
    emitirEliminacion() {
      this.$emit('eliminar', this.tarea.id);
    },
    toggleDetalles() {
      this.mostrarDetalles = !this.mostrarDetalles;
    },
    abrirCumplimientoModal() {
      this.mostrarModalCumplimiento = true;
    },
    cerrarCumplimientoModal() {
      this.mostrarModalCumplimiento = false;
    },
    toggleMenu() {
      this.mostrarMenu = !this.mostrarMenu;
    },
  },
};
</script>

<style scoped>
/* Contenedor principal: tarjeta ancha y compacta */
.task-card {
  background-color: #fff;
  border-radius: 8px;
  border-left: 5px solid var(--app-primary);
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;
  width: 100%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

/* Media query para pantallas pequeñas */
@media (max-width: 600px) {
  .task-card {
    padding: 0.5rem;
  }
  .task-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .info-compact {
    flex-direction: column;
    align-items: flex-start;
  }
  .info-right {
    margin-top: 0.5rem;
  }
  .btn-toggle-details {
    justify-content: flex-start;
  }
}

/* Encabezado: título y submenú de opciones */
.task-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
  position: relative;
}

.task-title {
  font-size: 1.1rem;
  font-weight: bold;
  margin: 0;
  /* Permitir que el texto se envuelva en varios renglones */
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}

/* Agregar lógica para detectar desbordamiento y aplicar animación si es necesario */
.mostrar-animacion {
  animation: slide 5s ease-in-out infinite;
}

.btn-delete {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  font-size: 1rem;
}

/* Información Compacta: distribución en dos bloques */
.info-compact {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  margin-bottom: 0.25rem;
}

.info-left {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.icon-info {
  font-size: 0.85rem;
  color: #6c757d;
}

/* Información del objeto (objetivo) */
.objective span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Bloque derecho: Badges para costo y duración con estilo outline minimalista */
.info-right {
  display: flex;
  gap: 0.5rem;
}

.badge {
  font-size: 0.8rem;
  padding: 0.3rem 0.5rem;
  border-radius: 12px;
  border: 1px solid #ccc;
  background-color: transparent;
  color: #333;
}

.badge-cost {
  border-color: var(--app-primary);
  color: var(--app-primary);
}

.badge-duration {
  border-color: #6c757d;
  color: #6c757d;
}

/* Cumplimiento */
.compliance-summary {
  display: flex;
  align-items: center;
  margin-bottom: 0.25rem;
}

.compliance-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 0.5rem;
}

.compliance-link {
  font-size: 0.85rem;
  color: var(--app-primary);
  text-decoration: underline;
  cursor: pointer;
}

/* Botón para expandir/ocultar detalles */
.btn-toggle-details {
  background: none;
  border: none;
  color: var(--app-primary);
  font-size: 0.85rem;
  padding: 0;
  margin-top: 0.25rem;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.btn-toggle-details font-awesome-icon {
  margin-right: 0.25rem;
}

/* Detalles Expandidos */
.task-details {
  padding: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 5px;
  font-size: 0.85rem;
  margin-top: 0.25rem;
}

/* Modal para Cumplimiento */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 100%;
}

.options-menu {
  position: absolute;
  top: 0;
  right: 0;
}

.menu-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.btn-options {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  color: #333;
}
</style>
